import _ from "lodash"
import MainContext from 'context/MainContext';
import { useContext } from 'react';

function useUser() {

    const context = useContext(MainContext)

    const getUser = () => {
        return context.user
    }

    const getUserName = () => {
        return context.user?.name
    }

    const getPrettyUserName = () => {
        const userName = getUserName()
        if (!userName) {
            return "USER"
        }
        return userName.charAt(0).toUpperCase() + userName.slice(1).substring(0, 2);
    }

    const userIsAdmin = () => {
        return context.user ? context.user.is_admin : false
    }

    const userIsSuperAdmin = () => {
        return context.user ? context.user.is_superadmin : false
    }

    const userIsMcr = () => {
        return context.user ? context.user.is_mcr : false
    }

    const userIsDev = () => {
        return context.user ? context.user?.roles?.find((el) => el?.name === "developer") : false
    }

    return {
        getUser: getUser,
        getUserName: getUserName,
        getPrettyUserName: getPrettyUserName,
        userIsSuperAdmin: userIsSuperAdmin,
        userIsAdmin: userIsAdmin,
        userIsMcr: userIsMcr,
        userIsDev: userIsDev
    };
}

export default useUser